module.exports = "//static.hsappstatic.net/LoginUI/static-1.14135/img/unsupported-browser.svg"